<script>
// import Cover from './Cover.vue'
export default {
    // components: {
    //     Cover
    // },
    props: {
        version: String,
        fullVersion: String,
        // platform: String,
        fixed: Boolean,
        versionObj: Object
    },
    data() {
        return {
            clickTimes: 0,
            showBonusScene: false,
        }
    },
    computed: {
        displayVersion() {
            if (this.fixed) {
                return {
                    version: 'V 1.0',
                    fullVersion: 'V 1.0.0'
                }
            } else {
                return {
                    version: this.version,
                    fullVersion: this.fullVersion
                }
            }
        },
    },
    methods: {
        change(index) {
            this.$emit('onChange', index)
            this.clickTimes = 0
        },
        click() {
            this.clickTimes++
            this.$emit('click', this.clickTimes)
        },
        getVersion() {
            window.open(this.versionObj.url)
        },
        update() {
            this.$emit('updateVersion')
        }
    }
}
</script>

<template>
<div class="carouselInfo">
    <el-carousel :autoplay=false arrow="hover" @change="change">
        <el-carousel-item :key="1">
            <img @click="click" class="logo" src="./assets/login_logo.svg">
            <p style="margin-bottom: 6px;" class="text"><span>发布版本</span>{{displayVersion.version}}</p>
            <p style="margin-bottom: 6px;" class="text"><span>完整版本</span>{{displayVersion.fullVersion}}
            <a style="color:rgba(255,255,255,1);" class="versionBox" v-if="versionObj &&versionObj.version != displayVersion.fullVersion" @click="update">版本更新</a></p>
            <p style="margin-bottom: 6px;" class="text"><span>生产日期</span></p>
            <p style="margin-bottom: 6px;" class="text"><span>产品型号</span>GMRS-RS-2019</p>
            <p style="margin-bottom: 6px;" class="text"><span>厂商名</span>珠海广目锐视医疗科技有限公司</p>
            <p style="margin-bottom: 6px;" class="text"><span>公司地址</span>珠海市高新区金鼎科技工业园金峰西路29号C区一楼120室</p>
            <p style="margin-bottom: 6px;" class="text"><span>联系方式</span>0756-3635909</p>
        </el-carousel-item>
        <el-carousel-item :key="2">
            <img @click="click" class="logo" src="./assets/login_logo.svg">
            <p style="margin-bottom: 6px;" class="text"><span>注册证编号</span>粤械注准20202210139</p>
            <p style="margin-bottom: 6px;" class="text"><span>注册人姓名</span>珠海广目锐视医疗科技有限公司</p>
            <p style="margin-bottom: 6px;" class="text"><span>产品名称</span>视感知觉训练软件</p>
            <p style="margin-bottom: 6px;" class="text"><span>型号、规格</span>GMRS-RS-2019</p>
            <p style="margin-bottom: 6px;" class="text"><span>注册人住所</span>珠海市高新区金鼎科技工业园金峰西路29号C区一楼120室</p>
            <p style="margin-bottom: 6px;" class="text"><span>结构及组成</span>主要由精细刺激训练，视觉技巧训练，双眼视功能训练，</p>
            <p style="margin-bottom: 6px;" class="text"><span></span>Gabor训练，对比敏感度训练，信息提取训练6个模块组成</p>
            <p style="margin-bottom: 6px;" class="text"><span>适应范围</span>适用于儿童轻、中度弱视及融合功能不足的治疗</p>
        </el-carousel-item>
        <el-carousel-item :key="3">
            <img @click="click" class="logo" src="./assets/login_logo.svg">
            <p style="margin-bottom: 6px;" class="text"><span>注册证编号</span>粤械注准20202210139</p>
            <p style="margin-bottom: 6px;" class="text"><span>注册人姓名</span>珠海广目锐视医疗科技有限公司</p>
            <p style="margin-bottom: 6px;" class="text"><span>产品名称</span>视感知觉训练软件</p>
            <p style="margin-bottom: 6px;" class="text"><span>型号、规格</span>GMRS-RS-2019</p>
            <p style="margin-bottom: 6px;" class="text"><span>生产日期</span></p>
            <p style="margin-bottom: 6px;" class="text"><span>使用期限</span>不适用</p>
            <el-alert title="其他其内容详见说明书" style="margin-top: 15px;" type="warning" :closable="false" show-icon>
            </el-alert>
        </el-carousel-item>
    </el-carousel>
</div>
</template>

<style lang="scss">
.carouselInfo {
    .text {
        >span {
            color: #646464;
            width: 90px;
            display: inline-block;
        }

        font-size:14px;
        font-weight:400;
        color:#00C1DE;
        line-height:20px;
    }

    .logo {
        position: absolute;
        // top: 110px;
        right: 22px;
        z-index: 20;
    }

    .el-carousel__container {
        height: 250px;

    }

    .el-carousel__indicator.is-active button {
        background-color: #00C1DE;
        height: 4px;
    }

    .el-carousel__indicator button {
        background-color: #A2A4A6;
        height: 4px;
    }
    .versionBox {
        cursor: pointer;
        color:rgba(255,255,255,1);
        display: inline-block;
        margin-left: 10px;
        width:72px;
        height:29px;
        background:rgba(0,193,222,1);
        border-radius:3px;
        text-align: center;
        font-size:14px;
        line-height:29px;
        text-decoration: none;
    }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/CarouselInfo.vue